/* global angular, moment */
/**
 * Created by lari on 27/04/2017.
 */
(function () {
    'use strict';
    angular.module('vcexam')
      .component('currentexams', {
        restrict: 'E',
        bindings: {
          // examinations: '='
          consultid: '<'
        },
        // templateUrl: 'exam/currentexams-component.tpl.html',
        template: `
          <uib-accordion close-others="oneAtATime">
            <div uib-accordion-group ng-repeat="exam in vm.examinations | filter: {active: true}  | orderBy: '-_id'"
                           is-open="vm.status.isOpen[$index]">
          <!-- exam header -->
          <uib-accordion-heading>
          <div class="row">
            <div class="col-xs-12 col-sm-8">
              <h4>
                <span ng-show="vm.status.isOpen[$index]" ng-click="vm.status.isOpen[$index] = !status.isOpen[$index]"><i class="fa fa-caret-up"></i></span>
                <span ng-hide="vm.status.isOpen[$index]" ng-click="vm.status.isOpen[$index] = !status.isOpen[$index]"><i class="fa fa-caret-down"></i></span>
                  {{exam.template.displayname}}&nbsp;<span style="color: #999999; font-size: smaller"
                  ng-show="exam.open === true && (exam.template.loadfiles === true || exam.template.shareid !== '')">(autom. Bildimport aktiv)</span></h4>
              </div>
            <div class="col-xs-12 col-sm-4" style="text-align: right">
              <h4>
              <!-- print btn radio toggle -->
              <a class="btn-group">
                  <a class="btn btn-success btn-sm" ng-model="exam.print" uib-tooltip="Drucken" uib-btn-radio="true"
                  style="border-top-right-radius: 0px; border-bottom-right-radius: 0px; "
                     ng-click="$event.stopPropagation(); vm.setprint(exam, true); "><i class="fa fa-print"></i></a><!--
                  --><a class="btn btn-danger btn-sm" ng-model="exam.print" uib-tooltip="Nicht drucken" uib-btn-radio="false"
                  style="border-top-left-radius: 0px; border-bottom-left-radius: 0px; "
                        ng-click="$event.stopPropagation(); vm.setprint(exam, false); "><i class="fa fa-ban"></i></a>
              </a><!-- finish exam button button-->
                <a class="btn btn-warning btn-sm" ng-click="$event.stopPropagation(); vm.finishExam(exam); "
                   ng-hide="exam.open === false"
                   uib-tooltip="Untersuchung abschließen">
                  <i class="fa fa-flag-checkered"></i>
                </a>
                <!-- textansicht button-->
                <a class="btn btn-primary btn-sm" ng-click="$event.stopPropagation(); editexam[$index] = false; "
                   ng-hide="vm.showview(exam.open, editexam[$index])"
                   uib-tooltip="Textansicht">
                  <i class="fa fa-table"></i>
                </a>
                <!-- Edit button -->
                <a class="btn btn-primary btn-sm" ng-click="$event.stopPropagation(); editexam[$index] = true;"
                   ng-hide="vm.showeditor(exam.open, editexam[$index])"
                   uib-tooltip="Editieren">
                  <i class="fa fa-edit"></i>
                </a>
                <!-- PDF ansicht button-->
                <a class="btn btn-info btn-sm" ng-click="$event.stopPropagation()"
                   href="{{vm.examPreviewUrl(exam._id, exam.patientid)}}"
                   target="_blank" uib-tooltip="PDF Vorschau"><i class="fa fa-eye"></i></a>
                   <!--             <a class="btn btn-info btn-sm" ng-click="$event.stopPropagation()"
                   href="/routes/pdfprinter/exampreview?patientid={{exam.patientid}}&examid={{exam._id}}&doctype=examfinding"
                   target="_blank" uib-tooltip="PDF Vorschau"><i class="fa fa-eye"></i></a>-->
                <!-- TODO: stress test exam identifcation by $index when deleting adding adding exams -->
                
    
                <!-- delete button-->
                 <a class="btn btn-danger btn-sm" ng-click="vm.deleteExam(exam)" uib-tooltip="Entfernen">
                  <i class="fa fa-remove"></i></a>
              </h4>
            </div>
          </div>
          </uib-accordion-heading>
        <!-- exam data -->
        <div class="row">
          <examview exam="exam" ng-if="vm.showview(exam.open, editexam[$index])"></examview>
          <div class="spacer-sides" ng-if="vm.showeditor(exam.open, editexam[$index])"><exameditor exam="exam" ></exameditor></div>
        </div>
        </div>  <!-- exam in openConsult.examinations -->
        </uib-accordion>
      `,
        controllerAs: 'vm',
        controller: ['$log', 'Rlog', 'Exam', 'ExamHelper', 'vertxEventBusService', '$window', 'PrintHelper',
          function ($log, Rlog, Exam, ExamHelper, vertxEventBusService, $window, PrintHelper) {
            let vm = this;
            vm.deleteExam = deleteExam;
            vm.finishExam = ExamHelper.finishExam;
            vm.showeditor = showeditor;
            vm.showview = showview;
            vm.setprint = setprint;
            vm.examPreviewUrl = PrintHelper.examPreviewUrl;

            vm.$onInit = function () {
              if (angular.isDefined(vm.consultid)) {
                let query = {consultid: vm.consultid};
                Exam.$search(query).$then(function (exams) {
                  vm.examinations = exams;
                })
              }
            };

            // vm.consultid might be late propagating, get exams on first change
            vm.$onChanges = function (changes) {
              if (!changes.isFirstChange) {
                // if (angular.isDefined(changes.consultid.currentValue)) {
                vm.consultid = changes.consultid.currentValue;
                if (angular.isDefined(vm.consultid)) {
                  Exam.$search({consultid: vm.consultid}).$then(function (exams) {
                    vm.examinations = exams;
                    // TODO: code only needed during development, remove before final release
                    for (let i = 0; i < vm.examinations.length; i++) {
                      if (angular.isUndefined(vm.examinations[i].print)) {
                        vm.examinations[i].print = true;
                        vm.examinations[i].$save();
                      }
                    }
                    // $log.debug('******* current exams : ', exams);
                  }, function (err) {
                    $log.error('exam lookup failed for consultid id: ', vm.consultid);
                    Rlog.error('exam', 'currentexams', 'exam lookup failed', {consultid: vm.consultid});
                  });
                }
              }
            };

            function setprint(exam, val) {
              exam.print = val;
              $log.debug('Changing exam print status to: ', val, exam);

              exam.$save();
            }

            function showeditor(open, edit) {
              return ((open === true && (angular.isUndefined(edit) || edit === true)) ||
                (open === false && edit === true));
            }


            function showview(open, edit) {
              return ((open === true && edit === false) ||
                (open === false && (edit === false || angular.isUndefined(edit))));
            }


            function deleteExam(exam) {
              exam.active = false;
              if (exam.$hasPendingActions()) {
                exam.$cancel();
              }
              exam.$save().$then(function () {
              }, function () {
                Rlog.debug('exam', 'currentexams', 'exam delete save failed', {examid: exam._id});
              });
            }


            vertxEventBusService.on('examinations.create', function (message) {
              $log.debug('debug: Exam create received: ', message);
              let messages = message.split(':');
              vm.examinations.$refresh().$then(function () {
                if (angular.isDefined(vm.status) && angular.isDefined(vm.status.isOpen)) {
                  vm.status.isOpen[0] = true;
                }
                $log.debug('debug: currentexams refreshed');
              }, function (error) {
                $log.debug('debug: currentexams could not refresh exams: ', error);
              });
            });

          }] // controller
      }); // component

// klammerfriedhof
  }
  ()
)
;